import { useEffect, useState } from "react";
import api from "../../lib/api";
import { GlassAvatar } from "./GlassConversation";

export const Bubble = ({ role, children, testid }) => (
  <div className={`flex ${role === "user" ? "justify-end" : "justify-start"} cai-fade-in`}>
    <div
      data-testid={testid}
      className={`max-w-[88%] rounded-[20px] px-3.5 py-2.5 text-[12.5px] leading-relaxed ${
        role === "user" ? "bg-white/90 text-[#2B4A6F] rounded-br-md" : "cai-glass text-white rounded-bl-md"
      }`}
    >
      {children}
    </div>
  </div>
);

export const Field = ({ label, value, onChange, type = "text", testid, ...rest }) => (
  <label className="block">
    <span className="block text-[9.5px] uppercase tracking-[0.16em] text-white/70 mb-1">{label}</span>
    <input
      type={type}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testid}
      style={{ colorScheme: "dark" }}
      className="w-full h-9 px-3 rounded-xl bg-white/15 border border-white/25 text-[12.5px] text-white placeholder:text-white/55 outline-none"
      {...rest}
    />
  </label>
);

export const GlassBtn = ({ primary, children, ...rest }) => (
  <button
    type="button"
    {...rest}
    className={`h-9 px-4 rounded-full text-[12.5px] font-semibold transition-[background-color,transform] active:scale-[0.97] disabled:opacity-50 ${
      primary ? "bg-white text-[#5B8FD0] hover:bg-white/90" : "bg-[#2B4A6F]/25 border border-white/35 text-white hover:bg-[#2B4A6F]/40"
    }`}
  >
    {children}
  </button>
);

export const PatientList = ({ query, onPick }) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    const t = setTimeout(
      () => api.get("/ai/patients", { params: { q: query } }).then(({ data }) => setList(data)).catch(() => {}),
      200
    );
    return () => clearTimeout(t);
  }, [query]);
  return (
    <div className="cai-glass rounded-[20px] p-1.5 cai-fade-in" data-testid="cai-flow-patients">
      {list.length === 0 && <div className="px-3 py-2 text-[12px] text-white/75">Sin resultados para «{query}»</div>}
      {list.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => onPick(p)}
          data-testid={`cai-flow-patient-${p.id}`}
          className="w-full text-left px-3 h-9 rounded-xl text-[13px] text-white hover:bg-white/15 transition-colors truncate"
        >
          {p.full_name}
        </button>
      ))}
    </div>
  );
};

export const DoctorList = ({ query, onPick }) => {
  const [list, setList] = useState(null);
  useEffect(() => {
    api.get("/chat/contacts").then(({ data }) => setList((data || []).filter((c) => c.role === "doctor"))).catch(() => setList([]));
  }, []);
  const q = (query || "").toLowerCase();
  const shown = (list || []).filter((d) => !q || `${d.name} ${d.specialty || ""}`.toLowerCase().includes(q));
  return (
    <div className="grid grid-cols-2 gap-2 cai-fade-in" data-testid="cai-flow-doctors">
      {list && shown.length === 0 && (
        <div className="col-span-2 cai-glass rounded-[18px] px-3 py-3 text-[12px] text-white/80">
          No tienes doctores en tu chat. Agrégalos desde la pestaña Chat.
        </div>
      )}
      {shown.map((d) => (
        <button
          key={d.id}
          type="button"
          onClick={() => onPick(d)}
          data-testid={`cai-flow-doctor-${d.id}`}
          className="cai-glass cai-glass-hover rounded-[18px] p-3 text-left text-white"
        >
          <GlassAvatar c={d} size={32} />
          <div className="mt-2 text-[12.5px] font-semibold leading-tight truncate">{d.name}</div>
          <div className="text-[11px] text-white/75 truncate">{d.specialty || "Doctor"}</div>
        </button>
      ))}
    </div>
  );
};
